import React from 'react';
import { User, Mail } from 'lucide-react';

const etapas = [
  'Nuevos Postulantes',
  'Hunting',
  'Posibles',
  'Entrevista Consultora',
  'Entrevista Psicologica',
  'Terna',
  'Contratado'
];

const KanbanBoard = ({ candidatos, onCandidatoClick }) => {
  return (
    <div className="flex overflow-x-auto pb-4 gap-4 mt-4 px-4 h-[400px]">
      {etapas.map((etapa) => (
        <div key={etapa} className="w-[280px] shrink-0 flex flex-col bg-gray-50 rounded-lg p-2 border border-gray-200 shadow-inner">
          <div className="flex justify-between items-center mb-3 px-2 pt-1 border-b border-gray-200 pb-2">
            <h4 className="font-bold text-xs text-gray-500 uppercase">{etapa}</h4>
            <span className="bg-white px-2 py-1 rounded text-xs font-bold text-gray-400 shadow-sm">
              {candidatos.filter(c => c.etapa_actual === etapa).length}
            </span>
          </div>

          <div className="flex-1 overflow-y-auto space-y-2 pr-1">
            {candidatos
              .filter(c => c.etapa_actual === etapa)
              .map(candidato => (
                <div 
                  key={candidato.id} 
                  onClick={() => onCandidatoClick(candidato)}
                  className="bg-white p-3 rounded shadow-sm border border-gray-100 cursor-pointer hover:border-emeral-green hover:shadow-md transition group"
                >
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-8 h-8 rounded-full bg-emeral-green bg-opacity-20 flex items-center justify-center shrink-0">
                      {candidato.foto_url ? (
                        <img src={candidato.foto_url} alt="" className="w-full h-full rounded-full object-cover" />
                      ) : (
                        <User size={16} className="text-emeral-green" />
                      )}
                    </div>
                    <div className="overflow-hidden">
                      <h5 className="text-sm font-bold text-gray-700 truncate group-hover:text-emeral-green transition-colors">{candidato.nombre}</h5>
                      <span className="text-[10px] text-gray-400 flex items-center gap-1 truncate">
                        <Mail size={10} /> {candidato.email}
                      </span>
                    </div>
                  </div>
                  {candidato.cv_url && (
                    <div className="text-[10px] bg-green-50 text-emeral-green px-2 py-1 rounded w-fit font-medium">📄 CV Adjunto</div>
                  )}
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default KanbanBoard;
